export function getRedirectUri() {
  return `${window.location.origin}/auth-redirect`
}
